import React from 'react';
export function FinalCTA() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <section className="bg-brand-primary" data-id="element-84" data-mp="84ntoq7nzptw">
      <div className="py-14 md:py-20 px-4 max-w-3xl mx-auto text-center" data-id="element-85" data-mp="83m7bpl77gwv">
        <h2 className="font-display text-2xl md:text-4xl font-bold text-white mb-4 leading-tight" data-id="element-86" data-mp="m3wx0parupgg">
          La versión de ti que se despierta ligera está a 21 días de
          distancia
        </h2>
        <p className="text-white/80 font-body mb-8 max-w-xl mx-auto leading-relaxed text-sm md:text-base" data-id="element-87" data-mp="vtq7fmz6gyj4">
          Con el sistema correcto. Con los sustitutos correctos. Con las
          herramientas para que el cambio sea tan fácil como inevitable.
        </p>

        <button onClick={scrollToPricing} className="bg-white hover:bg-brand-bg text-brand-primary font-heading font-bold text-lg py-4 px-9 rounded-xl transition-colors shadow-card-lg w-full md:w-auto mb-5" data-id="element-88" data-mp="zwmwnwj83sw1">
          Quiero acceder al sistema →
        </button>

        <div className="text-white/70 text-sm font-body tracking-wide" data-id="element-89" data-mp="2h3zse6rlyeob">
          🔒 Pago seguro · Garantía 30 días · Sin suscripción · Acceso
          inmediato
        </div>
      </div>
    </section>;
}